// src/utils/auth.js

const USERS_KEY = "users";
const ADMIN_EMAILS = ["monteroesteban@hotmail.com"];

export function registerUser(email, password) {
  const users = JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  if (users.find(u => u.email === email)) {
    return { success: false, message: "El correo ya está registrado." };
  }
  const newUser = { email, password, role: "user" };
  users.push(newUser);
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  localStorage.setItem(`favorites_${email}`, JSON.stringify([]));
  localStorage.setItem("currentUser", JSON.stringify({ email, role: newUser.role }));
  return { success: true, user: { email, role: newUser.role } };
}

export function loginUser(email, password) {
  const users = JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  const found = users.find(u => u.email === email && u.password === password);
  if (!found) return { success: false, message: "Credenciales inválidas." };
  const role = ADMIN_EMAILS.includes(email) ? "admin" : found.role;
  localStorage.setItem("currentUser", JSON.stringify({ email, role }));
  return { success: true, user: { email, role } };
}

export function getCurrentUser() {
  const raw = localStorage.getItem("currentUser");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function logoutUser() {
  localStorage.removeItem("currentUser");
}

export function getFavorites(email) {
  return JSON.parse(localStorage.getItem(`favorites_${email}`)) || [];
}

export function toggleFavorite(email, seriesId) {
  let favs = JSON.parse(localStorage.getItem(`favorites_${email}`)) || [];
  if (favs.includes(seriesId)) {
    favs = favs.filter(id => id !== seriesId);
  } else {
    favs.push(seriesId);
  }
  localStorage.setItem(`favorites_${email}`, JSON.stringify(favs));
  return favs;
}

export function isFavorite(email, seriesId) {
  const favs = JSON.parse(localStorage.getItem(`favorites_${email}`)) || [];
  return favs.includes(seriesId);
}
